import axios from "axios";
import { $observable, bodyHeader } from "../../common/libs/AxiosObservable";

export const generateQR = () => {
  let obj = JSON.stringify({});

  return $observable(
    axios.post("api/v1/admin/two-factor/generate-qr", obj, {
      headers: bodyHeader,
    })
  );
};

export const verifyQR = ({ code }) => {
  let params = JSON.stringify({
    code,
  });

  return $observable(
    axios.post("api/v1/admin/two-factor/verify-code", params, {
      headers: bodyHeader,
    })
  );
};

export const registerTFA = ({ code, enabled }) => {
  return $observable(
    axios.post(
      `api/v1/admin/two-factor/register-tfa?code=${code}&enabled=${enabled}`
    )
  );
};
